export default __webpack_public_path__ + "static/media/ruybon react cropped.31c144f3.png";